import { TextField } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import classNames from 'classnames';
import React from 'react';

type Props = {
  className: string;
  disabled?: boolean;
  handleChange?: (value: string) => void;
  id: string;
  label: string;
  value: string | null | undefined;
};

export const PlexTextField = ({ className, disabled, id, label, handleChange, value }: Props): React.ReactElement => {
  const classes = useStyles();
  return (
    <TextField
      id={id}
      label={label}
      className={classNames(className, classes.textField)}
      InputLabelProps={{
        className: classes.label,
        shrink: true,
      }}
      InputProps={{ classes: { root: classes.inputRoot } }}
      disabled={disabled}
      value={value}
      onChange={(event: React.ChangeEvent<{ name?: string; value: unknown }>): void => {
        handleChange && handleChange(event.target.value as string);
      }}
    />
  );
};

export const LABEL_PADDING_LEFT = 64;
export const PADDING_TOP = 20;
export const ROOT_PADDING_LEFT = 48;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      paddingLeft: LABEL_PADDING_LEFT,
      top: PADDING_TOP,
    },
    textField: {
      paddingTop: PADDING_TOP,
    },
    inputRoot: {
      paddingLeft: ROOT_PADDING_LEFT,
    },
  })
);
